import { PageCenter } from "@/components/PageCenter.tsx";
import { cn } from "@/lib/utils.ts";
import { SearchX } from "lucide-react";
import { Trans } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";

export function PageNotFoundError() {
  return (
    <PageCenter>
      <div className={cn("flex flex-col py-12 px-28 items-center justify-center gap-8")}>
        <SearchX className={"text-destructive"} size={50} />
        <h3>
          <Trans>404 — Page Not Found</Trans>
        </h3>
        <p className={"text-center text-muted-foreground"}>
          <Trans>
            This page isn’t in our records. Please check the link or return to the{" "}
            <Link className={"text-primary hover:underline"} to={"/"}>
              dashboard
            </Link>
            .
          </Trans>
        </p>
      </div>
    </PageCenter>
  );
}
